// extracted by mini-css-extract-plugin
export default {"menu":"MenuWiecej_menu__+qcoI","pozycja":"MenuWiecej_pozycja__GGU4W","teksty":"MenuWiecej_teksty__-TWv7","nieczynna":"MenuWiecej_nieczynna__YzquC","powod":"MenuWiecej_powod__FEfu4"};